import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@material-ui/core";
import React, { useEffect, useState,useMemo } from "react";
import axios from "axios";
import {
  APIURI,
  blueThemePodIds,
  customStyleGameIds,
  SOCKET_URI,
} from "../config";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import Loader from "../utils/Loader";
import io from "socket.io-client";
const socketNotification = io(`${SOCKET_URI}/notification`, {
  reconnection: true, // Enable automatic reconnection
  reconnectionAttempts: 10, // Number of reconnection attempts
  reconnectionDelay: 2000, // Delay between reconnection attempts (in milliseconds)
});

const LeaderBoard = () => {
  const [leaderBoardData, setLeaderBoardData] = useState([]);
  const [leaderBoardTitle, setLeaderBoardTitle] = useState("");
  const [podNotificationsOnTime, setPodNotificationsOnTime] = useState([]);
  const [pushNotificationModal, setPushNotificationModal] = useState(false);
  const [customTheme, setCustomTheme] = useState(false);
  const [pushNotificationData, setPushNotificationData] = useState("");
  const [podId2, setPodId2] = useState("");
  const [load, setLoad] = useState(true);
  const [podDetails, setPodDetails] = useState({});
  const [fonts, setFonts] = useState({
    title: null,
    body: null,
    button: null,
  });
  const [fontsLoaded, setFontsLoaded] = useState(false);
  const [leaderboardIcon, setLeaderBoardIcon] = useState("/assets/Trophy.svg");
  const podId = useParams();
  console.log(podId.podId);

  function convertSecondsToDHMS(seconds) {
    const oneMinute = 60;
    const oneHour = 60 * oneMinute;
    const oneDay = 24 * oneHour;

    const days = Math.floor(seconds / oneDay);
    seconds %= oneDay;

    const hours = Math.floor(seconds / oneHour);
    seconds %= oneHour;

    const minutes = Math.floor(seconds / oneMinute);
    seconds %= oneMinute;
    // console.log(days, hours, minutes, seconds);

    if (days) {
      return (
        <span>
          {days.toString()}:{hours.toString().padStart(2, "0")}:
          {minutes.toString().padStart(2, "0")}:
          {Math.floor(Number(seconds)).toString().padStart(2, "0")}
        </span>
      );
    } else if (hours) {
      return (
        <span>
          {hours.toString()}:{minutes.toString().padStart(2, "0")}:
          {Math.floor(Number(seconds)).toString().padStart(2, "0")}
        </span>
      );
    } else if (minutes) {
      return (
        <span>
          {minutes.toString()}:
          {Math.floor(Number(seconds)).toString().padStart(2, "0")}
        </span>
      );
    } else if (seconds) {
      return (
        <span>
          00:{Math.floor(Number(seconds)).toString().padStart(2, "0")}
        </span>
      );
    } else {
      return <span></span>;
    }
  }

  useEffect(() => {
    const root = document.getElementById("root");
    if (root) {
      root.classList.add("web-leaderboard");
    }
    // Cleanup: remove the class when the component unmounts
    return () => {
      if (root) {
        root.classList.remove("web-leaderboard");
      }
    };
  }, []);

  useEffect(() => {
    const handlePageShow = (event) => {
      // Check if the event's persisted property is false (back navigation)
      if (event.persisted) {
        // Reload the page after a brief delay
        setTimeout(() => {
          window.location.reload();
        }, 100); // Adjust the delay as needed
      }
    };

    window.addEventListener("pageshow", handlePageShow);

    return () => {
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, []);

  useEffect(() => {
    // Function to fetch data from the API
    const fetchData = async () => {
      axios
        .get(`${APIURI}/web-pods/leaderboard/${podId.podId}`, config)
        .then((res) => {
          const arry = [];
          let leaderBoardTitle = "";
          res.data.data.forEach((data) => {
            leaderBoardTitle = data.leaderboardTitle
              ? data.leaderboardTitle
              : "";
            if (data.active) {
              if (data.totalDuration) {
                arry.push(data);
              }
              // else {
              //   const dateCreated = new Date(data.date_created);
              //   const now = new Date();
              //   const differenceInMilliseconds = now - dateCreated;
              //   const secondsDifference = differenceInMilliseconds / 1000;
              //   console.log(secondsDifference);
              //   data.totalDuration = secondsDifference;
              //   arry.push(data);
              // }
            }
          });
          arry.sort((a, b) => a.totalDuration - b.totalDuration);
          console.log(arry, "1348as");
          if (leaderBoardTitle) setLeaderBoardTitle(leaderBoardTitle);
          setLeaderBoardData(arry);
          setLoad(false);
        });
    };

    // Set up the interval to call the API every 10 seconds
    const interval = setInterval(() => {
      fetchData();
    }, 7000); // 10000 milliseconds = 10 seconds

    // Clean up the interval when the component unmounts
    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    socketNotification.on("message", (data) => {
      console.log(data);
      setPushNotificationModal(true);
      setPushNotificationData(data.description);
    });
    return () => {
      socketNotification.disconnect();
    };
  }, [socketNotification]);

  useEffect(() => {
    // Function to fetch data from the API
    const fetchData = async () => {
      Object.keys(localStorage).forEach((key) => {
        if (key.includes("PushNotification_")) {
          localStorage.removeItem(key);
        }
      });
      axios
        .get(`${APIURI}/web-pods/allMessages/${podId2}`, config)
        .then((res2) => {
          if (
            res2.data.data.length &&
            res2.data.data[0].Pod_notifications.length > 0
          ) {
            console.log(res2.data.data[0].Pod_notifications, "all messages");
            let arry = [];
            res2.data.data[0].Pod_notifications.forEach((resData) => {
              if (resData.displayAt) {
                arry.push(resData);
                localStorage.setItem(
                  `PushNotification_${Math.floor(
                    Date.parse(resData.displayAt) / 1000
                  )}`,
                  resData.description
                );
              }
            });
            console.log(arry);

            // setPodNotificationsOnTime(arry);
          }
        });
    };

    // Set up the interval to call the API every 10 seconds
    const interval = setInterval(() => {
      if (podId2) {
        fetchData();
      }
    }, 5000); // 10000 milliseconds = 10 seconds

    // Clean up the interval when the component unmounts
    return () => {
      clearInterval(interval);
    };
  }, [podId2]);

  useEffect(() => {
    const ShowNotificationOnTime = () => {
      // const currentTimeStamp = Date.now();
      // var myDate = new Date(currentTimeStamp);
      // var pstDate = myDate.toLocaleString("en-US", {
      //   timeZone: "America/Los_Angeles",
      // });
      // console.log(Date.parse(pstDate), "pst date");
      // var now = new Date();
      // var utc = new Date(now.getTime() + now.getTimezoneOffset() * 60000);
      // console.log(
      //   "utcasdf",
      //   Math.floor(Date.parse(new Date().toISOString()) / 1000)
      // );
      let utc_date = Math.floor(Date.parse(new Date().toISOString()) / 1000);

      // var pst_now = new Date(pstDate);
      // console.log("pst to utc ", Date.parse(new Date(pstDate).toISOString()));

      let notificationVar = localStorage.getItem(
        `PushNotification_${utc_date}`
      );
      if (notificationVar) {
        setPushNotificationModal(true);
        setPushNotificationData(notificationVar);
      }
    };

    // Call the function every second (1000 milliseconds)
    const intervalId = setInterval(ShowNotificationOnTime, 1000);

    // To stop calling the function, clear the interval when the component unmounts
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const accessToken = localStorage.getItem("accesstoken");
  let config;
  config = {
    headers: { Authorization: `Bearer ${accessToken}` },
  };

  useEffect(() => {
    axios
      .get(`${APIURI}/web-pods/getPod/${podId.podId}`, config)
      .then((res) => {
        setPodDetails(res.data.podDetails);
        setLeaderBoardTitle(res.data.podDetails.leaderboardTitle);
        if(res.data.podDetails.theme.leaderboard_icon){
          setLeaderBoardIcon(`${APIURI}`+"/"+res.data.podDetails.theme.leaderboard_icon);
        } else {
          setLeaderBoardIcon('/assets/Trophy.svg');
        }

        if (customStyleGameIds.includes(res.data.podDetails.game_id)) {
          setCustomTheme(true);
        }
        if (res.data.podDetails && res.data.podDetails._id) {
          socketNotification.emit("joinRoom", `${res.data.podDetails._id}`);
          setPodId2(res.data.podDetails._id);
        }
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          axios
            .get(`${APIURI}/web-pods/podTheme/${podId.podId}`)
            .then((res) => {
              console.log(res.data, "theme details");

              const dataObj = res.data.data; // { _id, theme }
              const themeData = dataObj?.theme ?? null;

              // Set leaderboard icon
              if (themeData?.leaderboard_icon) {
                setLeaderBoardIcon(
                  `${APIURI}` + "/" + themeData.leaderboard_icon,
                );
              } else {
                setLeaderBoardIcon("/assets/Trophy.svg");
              }

              // ✅ Set podDetails with theme_enabled=true so themeStyles computes correctly
              setPodDetails({
                _id: dataObj?._id,
                theme: themeData,
                theme_enabled: res.data.theme_enabled ?? false,
              });
            })
            .catch((err) => {
              console.log("Theme fetch failed:", err);
            });
        }
      });
  }, []);
  const themeEnabled = podDetails?.theme_enabled ?? false;
  const theme = podDetails?.theme ?? null;
  useEffect(() => {
    const fetchFonts = async () => {
      try {
        const podId = podDetails?._id;

        const [titleRes, bodyRes, buttonRes] = await Promise.all([
          axios.get(`${APIURI}/pods/podFont/${podId}/title`),
          axios.get(`${APIURI}/pods/podFont/${podId}/body`),
          axios.get(`${APIURI}/pods/podFont/${podId}/button`),
        ]);

        setFonts({
          title: titleRes.data,
          body: bodyRes.data,
          button: buttonRes.data,
        });
      } catch (err) {
        console.log("Font API error", err);
      }
    };

    if (themeEnabled && podDetails?._id) {
      fetchFonts();
    }
  }, [themeEnabled, podDetails]);
  useEffect(() => {
    const loadFonts = async () => {
      if (!podDetails?._id || !themeEnabled) return;

      const podId = podDetails._id;

      const fontTypes = {
        title: "PodTitleFont",
        body: "PodBodyFont",
        button: "PodButtonFont",
      };

      const loadedFonts = {};

      for (const [type, fontName] of Object.entries(fontTypes)) {
        try {
          const fontUrl = `${APIURI}/pods/podFont/${podId}/${type}`;

          const font = new FontFace(fontName, `url(${fontUrl})`);
          const loaded = await font.load();

          document.fonts.add(loaded);
          setFontsLoaded(true);
          loadedFonts[type] = fontName;
        } catch (err) {
          console.log(`Error loading ${type} font`, err);
          setFontsLoaded(true);
        }
      }

      setFonts(loadedFonts);
    };

    loadFonts();
  }, [themeEnabled, podDetails]);
  // Build inline CSS variables from the theme object when theme is enabled
  const themeStyles = useMemo(() => {
    if (!themeEnabled || !theme) return {};

    return {
      "--theme-bg": theme.colors?.background ?? "#ffffff",
      "--theme-ui": theme.colors?.ui ?? "#000000",
      "--theme-btn-bg": theme.colors?.button_background ?? "#000000",
      "--theme-btn-text": theme.colors?.button_text ?? "#ffffff",
      "--theme-accent": theme.colors?.accent ?? "#000000",
        "--theme-font-title": fonts.title ?? "" ,
      "--theme-font-body": fonts.body ?? "",
      "--theme-font-button": fonts.button ?? "",
        
    };
    }, [themeEnabled, theme,fonts]);
  const themeCSS = useMemo(() => {
    if (!themeEnabled || !theme) return "";
    return `
        .solutionTitle {
          font-family: var(--theme-font-title)  !important;
          color: var(--theme-ui)  !important;
        }
        .team-title {
          font-family: var(--theme-font-button)  !important;
        }
        .team-stats-wrapper {
          font-family: var(--theme-font-body)  !important;
        }
        .web-leaderboard .leader--board--grid .leaderboard-card.Top--3--leaderboard .rank-badge {
          background-color: var(--theme-accent)  !important;
        }
        .web-leaderboard .leader--board--grid .leaderboard-card.Top--3--leaderboard {
            border-top: 2px solid var(--theme-accent)  !important;
            border-right: 2px solid var(--theme-accent)  !important;
        }
      `;
  }, [themeEnabled, theme]);
  if (load) {
    return <Loader />;
  }
  return (
    <>
      {themeStyles && Object.keys(themeStyles).length > 0 ? (
        <style>
          {`:root {
          ${Object.entries(themeStyles).map(([key, value]) => `${key}: ${value};`).join("\n")}
        }`}
        </style>
      ) : null}
    <style>{
    themeCSS
    }</style>
      <div
        className="leaderboard--main--screen"
      >
        <div className="Solution pod-start-screen">
          <div className="header">
            <h2
              className="solutionTitle">
              {leaderBoardTitle}
              <br /> <span style={{ fontSize: "22px" }}> Leaderboard </span>
            </h2>
          </div>
          {/* <hr /> */}
          <div className="trophyImg--div">
            <img src={leaderboardIcon} alt="" srcSet="" />
          </div>
          <div
            className="container-sol"
            style={{
              margin: "1rem 2rem 0 2rem",
              width: "auto",
              paddingBottom: "2rem",
            }}
          >
            <div className="container-code" style={{ width: "auto" }}>
              <div
                className={`leader--board--grid ${
                  leaderBoardData.length < 3 ? "leader-center-grid" : ""
                }`}
              >
                {leaderBoardData.map((data, index) => (
                  <div
                    key={index}
                    className={`leaderboard-card ${
                      index + 1 < 4
                        ? customTheme
                          ? "Top--3--leaderboard-custom-theme"
                          : "Top--3--leaderboard"
                        : "Normal--leaderboard"
                    }`}
                    style={{
                      borderTopColor: blueThemePodIds.includes(podId.podId)
                        ? "#67DCF3"
                        : "",
                      borderRightColor: blueThemePodIds.includes(podId.podId)
                        ? "#67DCF3"
                        : "",
                    }}
                  >
                    <div
                      className="rank-badge"
                      style={{
                        backgroundColor: blueThemePodIds.includes(podId.podId)
                          ? "#67DCF3"
                          : "",
                      }}
                    >
                      {index + 1}
                      {/* {index === 0 && (
                        <img
                          src="/assets/crown.svg"
                          alt="crown"
                          className="crown-icon"
                        />
                      )} */}
                    </div>
                    <div className="team-info">
                      <span className="team-title">{data.title}</span>
                      <span
                        className={`${customTheme ? "text-white" : "team-stats-wrapper"}`}
                      >
                        <div className="team-stats">
                          TOTAL TIME{" "}
                          {data.totalDuration
                            ? convertSecondsToDHMS(data.totalDuration)
                            : ""}
                        </div>
                        <div className="team-stats">
                          PENALTIES{" "}
                          {data.penaltyDuration
                            ? `${(data.penaltyDuration / 60).toFixed(2)} MIN`
                            : "0 MIN"}
                        </div>
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* push nofication  */}
      <Dialog
        open={pushNotificationModal}
        onClose={() => {
          setPushNotificationModal(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="PopOver"
      >
        {/* <DialogTitle id="alert-dialog-title">Message</DialogTitle> */}
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {/* <div dangerouslySetInnerHTML={createMarkup(pushNotificationData)} /> */}
            <div>
              <p style={
                    themeEnabled && theme ? {
                        ...themeStyles,
                      fontFamily: "var(--theme-font-body) !important"
                    }:{}
                  }>{pushNotificationData}</p>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setPushNotificationModal(false)}
            style={{
              marginBottom: "2.2rem"
            }}
            className="dialog-btn-dismiss"
            autoFocus
            variant="contained"
          >
            Okay
          </Button>
          {/* <Camera onTakePhoto = { (dataUri) => { handleTakePhoto(dataUri); } }/> */}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default LeaderBoard;
